import { whiteList } from 'xss';

declare module 'xss' {
  namespace XSS {
    interface IWhiteList {
      time?: string[];
    }
  }
}

whiteList.time = ['datetime', 'data-local'];
